import React, { useState } from "react";

const puzzles = [
    { encrypted: "KDUPDUH", key: 3, answer: "HARDWARE", hint: "Componenti fisici" },
    { encrypted: "SURJUDP", key: 3, answer: "PROGRAM", hint: "Software eseguibile" },
    { encrypted: "QHWZRUN", key: 3, answer: "NETWORK", hint: "Rete di computer" }
];

export default function CryptoPuzzle() {
    const [current, setCurrent] = useState(0);
    const [answer, setAnswer] = useState("");
    const [score, setScore] = useState(0);
    const [done, setDone] = useState(false);
    const [started, setStarted] = useState(false);
    const [feedback, setFeedback] = useState("");

    const check = () => {
        if (answer.toUpperCase() === puzzles[current].answer) {
            setScore(score + 1);
            setFeedback("✓");
            setTimeout(() => {
                if (current + 1 < puzzles.length) {
                    setCurrent(current + 1);
                    setAnswer("");
                    setFeedback("");
                } else {
                    setDone(true);
                }
            }, 1000);
        } else {
            setFeedback("✗");
            setTimeout(() => setFeedback(""), 800);
        }
    };

    if (!started) {
        return (
            <div style={{textAlign:"center",padding:"1rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#facc15",marginBottom:"0.5rem"}}>
                    <i className="fas fa-lock" style={{marginRight:"6px"}}></i> Crypto Puzzle
                </h4>
                <p style={{fontSize:"0.85rem",marginBottom:"1rem"}}>Decifra il codice Caesar!</p>
                <button onClick={() => setStarted(true)} style={{background:"linear-gradient(135deg,#facc15,#ca8a04)",border:"none",color:"#000",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (done) {
        return (
            <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#facc15",marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Completato!
                </h4>
                <p style={{fontSize:"1.5rem",fontWeight:"700",color:"#22c55e",marginBottom:"1rem"}}>
                    {score}/{puzzles.length}
                </p>
                <button onClick={() => {setStarted(true);setCurrent(0);setScore(0);setDone(false);setAnswer("");}} style={{background:"linear-gradient(135deg,#16a34a,#065f46)",border:"none",color:"#fff",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    return (
        <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
            <div style={{marginBottom:"1rem",color:"#94a3b8",fontSize:"0.85rem"}}>
                Puzzle {current + 1} di {puzzles.length} - Punteggio: {score}
            </div>
            <div style={{padding:"0.6rem",background:"rgba(59,130,246,0.1)",borderRadius:"0.5rem",marginBottom:"1rem",fontSize:"0.8rem",color:"#94a3b8"}}>
                💡 {puzzles[current].hint} (Caesar Cipher - Shift: {puzzles[current].key})
            </div>
            <div style={{fontSize:"2rem",fontWeight:"700",color:"#ef4444",marginBottom:"1.5rem",fontFamily:"monospace",letterSpacing:"0.3rem"}}>
                {puzzles[current].encrypted}
            </div>
            <input type="text" value={answer} onChange={(e) => setAnswer(e.target.value)} onKeyPress={(e) => e.key === "Enter" && answer && check()}
                   style={{width:"100%",padding:"0.8rem",borderRadius:"0.5rem",border:"2px solid rgba(255,255,255,0.1)",background:"rgba(255,255,255,0.05)",color:"#fff",fontSize:"1.2rem",textAlign:"center",outline:"none",marginBottom:"1rem",fontFamily:"monospace"}}
                   placeholder="DECIFRA QUI..." />
            {feedback && <div style={{fontSize:"2rem",color:feedback==="✓"?"#22c55e":"#ef4444",fontWeight:"700",marginBottom:"1rem"}}>{feedback}</div>}
            <button onClick={check} disabled={!answer} style={{background:answer?"linear-gradient(135deg,#2563eb,#1e40af)":"rgba(255,255,255,0.1)",border:"none",color:"#fff",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:answer?"pointer":"not-allowed",opacity:answer?1:0.5,width:"100%"}}>
                <i className="fas fa-key" style={{marginRight:"6px"}}></i> Decifra
            </button>
        </div>
    );
}